import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  public handleError(error: Error): void {
    console.error('An unhandled error occurred', error);
  }
}
